import { WebVTTParser } from "webvtt-parser";

export const isWebVttValid = (value: string) => {
  if (!value) return true;

  const vttText = atob(value.replace(/data:\S+,/, ""));
  const parser = new WebVTTParser();
  const result = parser.parse(vttText);

  return !result?.errors?.length;
};
